import { Link } from "react-router-dom";

const SITE_LINKS = [
  { label: "首页", to: "/" },
  { label: "影视作品", to: "/works" },
  { label: "明星动态", to: "/news" },
  { label: "关于佐山爱", to: "/about" },
];

const CATEGORY_LINKS = [
  { label: "电影作品", to: "/works?type=movie" },
  { label: "电视剧作品", to: "/works?type=tv" },
  { label: "最新动态", to: "/news" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-200">
      <div className="px-5 md:px-10 pt-14 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-5">
              <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-accent-500 text-primary-950 font-heading font-bold">
                爱
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading font-bold text-lg text-background-50">佐山爱</span>
                <span className="text-[10px] tracking-[0.25em] uppercase text-background-400">
                  SAYAMA AI
                </span>
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-300 max-w-md">
              佐山爱影视品牌站致力于为影迷提供全面的影视作品信息与最新明星动态，
              涵盖电影、电视剧等多种类型，带来全方位的娱乐资讯体验。
            </p>
            <div className="flex items-center gap-3 mt-6">
              {[
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-instagram-line", label: "Instagram" },
                { icon: "ri-youtube-line", label: "YouTube" },
                { icon: "ri-mail-line", label: "邮箱" },
              ].map((item) => (
                <span
                  key={item.label}
                  title={item.label}
                  className="flex items-center justify-center w-9 h-9 rounded-md bg-white/5 text-background-300 hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer"
                >
                  <i className={`${item.icon} text-base`} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 text-sm tracking-wide mb-4">
              站内导航
            </h4>
            <ul className="space-y-2.5">
              {SITE_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 text-sm tracking-wide mb-4">
              作品分类
            </h4>
            <ul className="space-y-2.5">
              {CATEGORY_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            © 2024 佐山爱影视品牌站 · 本站内容为演示数据，仅供展示使用
          </p>
          <p className="text-xs text-background-400">
            友情提示：所有作品信息均为虚构示例，不代表真实影视资料
          </p>
        </div>
      </div>
    </footer>
  );
}